
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/get-support",
      function () {
        return require("private-next-pages/support/get-support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/get-support"])
      });
    }
  